module.exports = __webpack_public_path__ + "static/media/seagulls.781de5cf.mov";